import { render, staticRenderFns } from "./VeHrPeixunShenheForm.vue?vue&type=template&id=727f6800"
import script from "./VeHrPeixunShenheForm.vue?vue&type=script&lang=js"
export * from "./VeHrPeixunShenheForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports